export const languagesConstants = {
    ALL_LANGUAGES_PENDING  : 'ALL_LANGUAGES_PENDING',
    ALL_LANGUAGES_FULFILLED: 'ALL_LANGUAGES_FULFILLED',
    ALL_LANGUAGES_REJECTED : 'ALL_LANGUAGES_REJECTED',
};
